// extracted by mini-css-extract-plugin
export var book = "Book-module--book--+TE8q";
export var bookAuthor = "Book-module--bookAuthor--z3+8n";
export var bookCta = "Book-module--bookCta--q9kUw";
export var bookImage = "Book-module--bookImage--uabSJ";
export var bookInfo = "Book-module--bookInfo--6Ckg5";
export var bookPublisher = "Book-module--bookPublisher--mhFZu";
export var bookTitle = "Book-module--bookTitle--LEJEZ";
export var intro = "Book-module--intro--Fqx7J";
export var introByLine = "Book-module--introByLine--UIr7u";
export var introHeadline = "Book-module--introHeadline--3ibUx";
export var introText = "Book-module--introText--16rDx";
export var name = "Book-module--name--lk84y";
export var root = "Book-module--root--fbIWb";
export var share = "Book-module--share--v5h6d";
export var text = "Book-module--text--Phg2K";
export var wrapper = "Book-module--wrapper--ZpqO0";